import React from "react";

/**
 * Renders a single JSON-LD <script> tag with the given schema object.
 * Use for SEO-critical pages where Google's rich-snippets engine reads
 * structured data (BlogPosting, LocalBusiness, ItemList, Place, etc.).
 *
 * Pass a fully-formed schema object (including "@context" + "@type").
 * Pass `id` to React-key the script so multiple JSON-LDs can co-exist
 * on the same page without clobbering each other.
 */
const JsonLd = ({ schema, id }) => {
  if (!schema) return null;
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      data-jsonld-id={id || undefined}
      data-testid={id || undefined}
    />
  );
};

export default JsonLd;
